import React from "react";
import HomePage from "../../components/HomePage";

export default function Home() {
  return <HomePage />;
}
